module.exports = __webpack_public_path__ + "static/img/10.cc1527b.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/10.png
// module id = 8iLe
// module chunks = 7